import { render, staticRenderFns } from "./CmdrStatistics.vue?vue&type=template&id=11b05e17&"
import script from "./CmdrStatistics.vue?vue&type=script&lang=js&"
export * from "./CmdrStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports